import Vue from 'vue';
import VueI18n from 'vue-i18n';

console.log('Using i18n');
Vue.use(VueI18n);

// Ready translated locale messages
const messages = {};

// our default language that is preloaded
const loadedLanguages = [];

const DEFAULT_LOCALE = "it";

// Create VueI18n instance with options
export const i18n = new VueI18n({
  locale: DEFAULT_LOCALE, // set locale
  fallbackLocale: DEFAULT_LOCALE,
  messages, // set locale messages
});

// =============================================================================
// GET LANGUAGE FILE FROM SERVER
// =============================================================================

import * as $ from 'jquery';

function getFileFromServer(lang) {
  return $.get('/i18n/' + lang + '.json');
}

// =============================================================================
// STORAGE RELATED ACCESSORS
// =============================================================================

export function getLanguage() {
  const language = localStorage.getItem('language');
  if (!language) {
    return DEFAULT_LOCALE;
  }
  return language;
}

function setLanguage(language) {
  i18n.locale = language;
  document.querySelector('html').setAttribute('lang', language);
  localStorage.setItem('language', language);
  return language;
}

function getDateFormat() {
  let dateFormat = localStorage.getItem('dateFormat');
  if (!dateFormat) {
    dateFormat = "yyyy/mm/dd";
  }
  switch (dateFormat) {
    case 'yyyy/mm/dd': return 'YYYY/MM/DD';
    case 'dd/mm/yyyy': return 'DD/MM/YYYY';
    default:
      throw Error('Unsupported date format: ' + dateFormat);
  }
}

function setDateFormat(dateFormat) {
  switch (dateFormat) {
    case 'yyyy/mm/dd':
    case 'dd/mm/yyyy':
      localStorage.setItem('dateFormat', dateFormat);
      break;
    default:
      throw Error('Unsupported date format: ' + dateFormat);
  }
}

function getDateTimeFormat() {
  return getDateFormat() + ' HH:mm:ss';
}

// =============================================================================
// LANGUAGE LOADING
// =============================================================================

export function loadLanguageAsync(lang) {
  console.log('current locale', i18n.locale)
  console.log('requested locale', lang)

  if (!lang) {
    lang = getLanguage();
  }

  let forceFirstLoad = false;
  if (loadedLanguages.length < 1) {
    forceFirstLoad = true;
    if (!lang) {
      lang = DEFAULT_LOCALE;
    }
  }

  if (lang && (i18n.locale !== lang || forceFirstLoad)) {
    if (!loadedLanguages.includes(lang)) {
      return getFileFromServer(lang)
      .then(msgs => {
        console.log('msgs', msgs)
        i18n.setLocaleMessage(lang, msgs[lang])
        loadedLanguages.push(lang)
        return setLanguage(lang)
      })
    }
    return Promise.resolve(setLanguage(lang))
  }

  return Promise.resolve(i18n.locale)
}

// =============================================================================
// SETUP
// =============================================================================

import { initAccounting } from 'core/utils';

initAccounting();

export function setupI18n(settings) {
  console.log('Setting up i18n', settings);
  setDateFormat(settings.dateFormat);
  loadLanguageAsync(settings.language);
}

// =============================================================================
// UTILITIES
// =============================================================================

import { text2moment, moment2text } from 'core/utils'
import * as moment from 'moment';

export function representDate(orig) {
  if (orig === null || orig === undefined) {
    return orig;
  }

  const m = moment.isMoment(orig) ? m : text2moment(orig);

  const fmt = getDateFormat();
  return moment2text(m, fmt);
}

export function representDateTime(orig) {
  if (orig === null || orig === undefined) {
    return orig;
  }

  const m = moment.isMoment(orig) ? m : text2moment(orig);

  const fmt = getDateTimeFormat();
  return moment2text(m, fmt);
}
